import api from "@/shared/api/api";

import type {
  AddTemplateCategoryPayload,
  AssetUploadResponse,
  CreateTemplatePayload,
  GetTemplatesParams,
  PaginatedTemplates,
  RequestAssetUploadPayload,
  TemplateRecord,
  UpdateTemplatePayload,
} from "./templates.types";

export const templatesApi = {
  list: async (
    params?: GetTemplatesParams,
    signal?: AbortSignal,
  ): Promise<PaginatedTemplates> => {
    const mapped: Record<string, unknown> = {};
    const p = params ?? {};
    if (p.page !== undefined) mapped.page = p.page;
    if (p.limit !== undefined) mapped.limit = p.limit;
    if (p.name !== undefined) mapped.name = p.name;
    if (p.status !== undefined) mapped.status = p.status;
    return api<PaginatedTemplates>({
      url: "/v1/templates",
      method: "GET",
      params: mapped,
      signal,
    });
  },

  get: async (id: string, signal?: AbortSignal): Promise<TemplateRecord> => {
    return api<TemplateRecord>({
      url: `/v1/templates/${id}`,
      method: "GET",
      signal,
    });
  },

  create: async (payload: CreateTemplatePayload): Promise<TemplateRecord> => {
    return api<TemplateRecord>({
      url: "/v1/templates",
      method: "POST",
      data: payload,
    });
  },

  update: async (
    id: string,
    payload: UpdateTemplatePayload,
  ): Promise<TemplateRecord> => {
    return api<TemplateRecord>({
      url: `/v1/templates/${id}`,
      method: "PUT",
      data: payload,
    });
  },

  remove: async (id: string): Promise<void> => {
    await api<void>({
      url: `/v1/templates/${id}`,
      method: "DELETE",
    });
  },

  addCategory: async (
    id: string,
    payload: AddTemplateCategoryPayload,
  ): Promise<TemplateRecord> => {
    return api<TemplateRecord>({
      url: `/v1/templates/${id}/categories`,
      method: "POST",
      data: payload,
    });
  },

  removeCategory: async (id: string, categoryId: string): Promise<void> => {
    await api<void>({
      url: `/v1/templates/${id}/categories/${categoryId}`,
      method: "DELETE",
    });
  },

  requestAssetUpload: async (
    id: string,
    payload: RequestAssetUploadPayload,
  ): Promise<AssetUploadResponse> => {
    return api<AssetUploadResponse>({
      url: `/v1/templates/${id}/assets`,
      method: "POST",
      data: payload,
    });
  },
};
